/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './subscription-plan.reducer';

export const SubscriptionPlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const subscriptionPlanEntity = useAppSelector(state => state.subscriptionPlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="subscriptionPlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.subscriptionPlan.detail.title">SubscriptionPlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.id}</dd>
          <dt>
            <span id="serviceType">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.serviceType">Service Type</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.serviceType}</dd>
          <dt>
            <span id="subscriptionType">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.subscriptionType">Subscription Type</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.subscriptionType}</dd>
          <dt>
            <span id="period">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.period">Period</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.period}</dd>
          <dt>
            <span id="amount">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.amount">Amount</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.amount}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.subscriptionPlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{subscriptionPlanEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/subscription-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/subscription-plan/${subscriptionPlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SubscriptionPlanDetail;
